// extracted by mini-css-extract-plugin
export default {"card":"current-user-password-totp-card_card__2Lb3J"};